import type { components } from '@connected/api-client/api.generated';
import type { FormApi, ReactFormApi } from '@tanstack/react-form';
import type { ZodValidator } from '@tanstack/zod-form-adapter';

import { Accordion } from '@connected/ui/components/accordion';

import type { Remark } from '../utils/observation-types';

import { ObservationReportFields } from './observation-report-fields';

type ObservationAccordionItemProps = {
    form: FormApi<Remark, ZodValidator> & ReactFormApi<Remark, ZodValidator>;
    reportIndex: number;
    classificationData: components['schemas']['ListElectricalObservationClassificationForProjectQueryResult'] | undefined;
    disabled: boolean;
};

export function ObservationAccordionItem({
    form,
    reportIndex,
    classificationData,
    disabled,
}: ObservationAccordionItemProps) {
    return (
        <form.Subscribe
            selector={(state) => {
                const currentReport = state.values.reports[reportIndex];
                return {
                    currentReport,
                    isEnabled: currentReport?.enabled ?? false,
                };
            }}
        >
            {({ currentReport, isEnabled }) => {
                // Only render accordion item if report is enabled
                if (!isEnabled || !currentReport) {
                    return null;
                }

                return (
                    <Accordion.Item value={currentReport.inspectionKind}>
                        <Accordion.Content className="flex flex-col gap-6">
                            <ObservationReportFields
                                form={form}
                                reportIndex={reportIndex}
                                inspectionKind={currentReport.inspectionKind}
                                classificationData={classificationData}
                                disabled={disabled}
                                isSingleClassification={false}
                            />
                        </Accordion.Content>
                    </Accordion.Item>
                );
            }}
        </form.Subscribe>
    );
}
